import type { TFunction } from "i18next";
import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { DIMENSION_PRESET_SWATCHES } from "../const/const";

export type TDimensionType = "text" | "dropdown";

export type TDimensionFormState = {
  name: string;
  type: TDimensionType;
  options: string[];
  color: string;
};

export function emptyDimensionForm(): TDimensionFormState {
  return { name: "", type: "text", options: [], color: DIMENSION_PRESET_SWATCHES[0] };
}

export function dimensionSubtitle(t: TFunction<"projects">, d: TOrganizationProjectDimension): string {
  if (d.type === "dropdown") return t("dimensions.subtitleDropdown", { count: d.options.length });
  return t("dimensions.subtitleText");
}

export function dimensionFormFromExisting(d: TOrganizationProjectDimension): TDimensionFormState {
  return {
    name: d.name,
    type: d.type,
    options: [...d.options],
    color: d.color || DIMENSION_PRESET_SWATCHES[0]
  };
}
